import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { publicApi } from "@/lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    publicApi.get("/public/faqs").then(({ data }) => setFaqs(data || [])).catch(() => {});
  }, []);

  return (
    <section id="faq" className="section">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6 }} className="text-center"
        >
          <p className="text-[11px] tracking-[0.22em] uppercase text-slate-500">Common questions</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A1930] mt-3 leading-[1.05]">
            Everything you might be wondering.
          </h2>
        </motion.div>

        <div className="mt-12" data-testid="faq-accordion">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={f.faq_id || i} value={`item-${i}`} className="border-slate-200">
                <AccordionTrigger className="text-left font-display text-lg text-[#0A1930]" data-testid={`faq-trigger-${i}`}>
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-[15px] leading-relaxed">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
